import React from 'react';

export function InternationalTaxProfile() {
  return <p>Display tax profile</p>;
}

export default InternationalTaxProfile;
